import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUSINESS = {
  name: "Firm Foundations Construction",
  address: "30546 Sutter Rd, Lucerne Valley, CA 92356",
  email: "info@firmbuilds.com",
  phone: "760-590-6672",
  phoneHref: "tel:+17605906672",
  area: "Serving all of the High Desert and all surrounding areas",
  facebook: "https://www.facebook.com/BuildUponTheRock?mibextid=ZbWKwL",
};

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export const money = (n) =>
  Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD" });

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
